import { Injectable } from '@angular/core';
import * as d3 from 'd3';

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService {
  alertChime = true;
  buildingCameraScope: any = null;
  selectedOrgs: any[] = [];
  numberOfUsersFiltered = 0;
  numberOfOrganisationFiltered= 0;
  orgTreeItemList: any[] = [];
  orgTreeItemListAll: any = null;
  orgTreeItemListTop: any = null;
  selectedOrgIds: any[] = [];
  flightTrackerDataSet: any[] = [];
  handlerLeftClickFlight: any = null;
  flightTrackerUpdateInterval: any = null;
  homeLocationsAll: any[] = [];
  homeLocationsAllDictionary: any = null;
  countryList: any[] = [];
  showStormLayer = true;
  perimeterIdForIncidentCreation: any = null;
  originalOrgIdForIncidentCreation: any = null;
  alertToAddToMyTasks: any = null;
  incidentOptions: any = null;
  selectedGroup: any = null;
  numberOfUserProcessed = 0;
  numberOfUserToProcess = 0;
  isProcessingUser = false;
  currentEventsProcallsPollerIsRunning = false;
  liveIncidentPollerIsRunning = false;
  isLoadingPlaybackDevices = false;
  isProcessingPlaybackDevices = false;
  isStatsPlaybackDevices = false;
  numberOfPlaybackDevicesToProcess = 0;
  numberOfPlaybackDevicesProcessed = 0;
  numberOfPlaybackDevicesStatsToDo = 0;
  numberOfPlaybackDevicesStatsDone = 0;
  newGeofenceData: any[] = [];
  userClusterList: any[] = [];
  orgTreeList: any[] = [];
  setBuildingCameraScope(scope: any) { this.buildingCameraScope = scope; }
  getBuildingCameraScope() { return this.buildingCameraScope; }

  setAlertChime(state: boolean) { this.alertChime = state; }
  getAlertChime() { return this.alertChime; }

  setSelectedOrgs(data: any[]) { this.selectedOrgs = data; }
  getSelectedOrgs() { return this.selectedOrgs; }

  setNumberOfUsersFiltered(n: number) { this.numberOfUsersFiltered = n; }
  getNumberOfUsersFiltered() { return this.numberOfUsersFiltered; }

  setNumberOfOrganisationFilter(n: number) { this.numberOfOrganisationFiltered = n; }
  getNumberOfOrganisationFilter() { return this.numberOfOrganisationFiltered; }
  

  setFlightTrackerDataSet(n: any[]) { this.flightTrackerDataSet = n; }
  getFlightTrackerDataSet() { return this.flightTrackerDataSet; }

  setHandlerLeftClickFlight(n: any) { this.handlerLeftClickFlight = n; }
  getHandlerLeftClickFlight() { return this.handlerLeftClickFlight; }

  setFlightTrackerUpdateInterval(n: any) { this.flightTrackerUpdateInterval = n; }
  getFlightTrackerUpdateInterval() { return this.flightTrackerUpdateInterval; }

  setHomeLocationsAll(n: any[]) { this.homeLocationsAll = n; }
  getHomeLocationsAll() { return this.homeLocationsAll; }

  setHomeLocationsAllDictionary(n: any) { this.homeLocationsAllDictionary = n; }
  getHomeLocationsAllDictionary() { return this.homeLocationsAllDictionary; }

  setCountryList(n: any[]) { this.countryList = n; }
  getCountryList() { return this.countryList; }

  setOrgTree(n: any[]) { this.orgTreeList = n;}
  getOrgTree() { return this.orgTreeList; }

  setOrgTreeItemList(n: any[]) { this.orgTreeItemList = n; }
  getOrgTreeItemList() { return this.orgTreeItemList; }

  setSelectedOrgIds(n: any[]) { this.selectedOrgIds = n; }
  getSelectedOrgIds() { return this.selectedOrgIds; }

  setOrgTreeItemListAll(n: any[]) {
    this.orgTreeItemListAll = n;
    // top orgs are those whose parent is not among the org tree
    const allOrgs = (this.orgTreeItemListAll || []).filter((org: any) => org.type === 'org');
    const allOrgIds = allOrgs.map((org: any) => org.organization.id);
    this.orgTreeItemListTop = allOrgs.filter((org: any) =>
      !allOrgIds.includes(org.organization.parentId) && !org.organization.groupId
    );
  }
  getOrgTreeItemListAll() { return this.orgTreeItemListAll; }
  getOrgTreeItemListTop() { return this.orgTreeItemListTop; }

  setShowStormLayer(n: boolean) { this.showStormLayer = n; }
  getShowStormLayer() { return this.showStormLayer; }

  setPerimeterIdForIncidentCreation(n: any) { this.perimeterIdForIncidentCreation = n; }
  getPerimeterIdForIncidentCreation() { return this.perimeterIdForIncidentCreation; }

  setOriginalOrgIdForIncidentCreation(n: any) { this.originalOrgIdForIncidentCreation = n; }
  getOriginalOrgIdForIncidentCreation() { return this.originalOrgIdForIncidentCreation; }

  setAlertToAddToMyTasks(n: any) { this.alertToAddToMyTasks = n; }
  getAlertToAddToMyTasks() { return this.alertToAddToMyTasks; }

  setIncidentOptions(n: any) { this.incidentOptions = n; }
  getIncidentOptions() { return this.incidentOptions; }

  setSelectedGroup(n: any) { this.selectedGroup = n; }
  getSelectedGroup() { return this.selectedGroup; }

  setNumberOfUserProcessed(n: number) { this.numberOfUserProcessed = n; }
  getNumberOfUserProcessed() { return this.numberOfUserProcessed; }

  setNumberOfUserToProcess(n: number) { this.numberOfUserToProcess = n; }
  getNumberOfUserToProcess() { return this.numberOfUserToProcess; }

  setIsProcessingUser(n: boolean) { this.isProcessingUser = n; }
  getIsProcessingUser() { return this.isProcessingUser; }

  setCurrentEventsProcallsPollerIsRunning(n: boolean) { this.currentEventsProcallsPollerIsRunning = n; }
  getCurrentEventsProcallsPollerIsRunning() { return this.currentEventsProcallsPollerIsRunning; }

  setLiveIncidentPollerIsRunning(n: boolean) { this.liveIncidentPollerIsRunning = n; }
  getLiveIncidentPollerIsRunning() { return this.liveIncidentPollerIsRunning; }

  setIsLoadingPlaybackDevices(n: boolean) { this.isLoadingPlaybackDevices = n; }
  getIsLoadingPlaybackDevices() { return this.isLoadingPlaybackDevices; }

  setIsProcessingPlaybackDevices(n: boolean) { this.isProcessingPlaybackDevices = n; }
  getIsProcessingPlaybackDevices() { return this.isProcessingPlaybackDevices; }

  setIsStatsPlaybackDevices(n: boolean) { this.isStatsPlaybackDevices = n; }
  getIsStatsPlaybackDevices() { return this.isStatsPlaybackDevices; }

  setNumberOfPlaybackDevicesToProcess(n: number) { this.numberOfPlaybackDevicesToProcess = n; }
  getNumberOfPlaybackDevicesToProcess() { return this.numberOfPlaybackDevicesToProcess; }

  setNumberOfPlaybackDevicesProcessed(n: number) { this.numberOfPlaybackDevicesProcessed = n; }
  getNumberOfPlaybackDevicesProcessed() { return this.numberOfPlaybackDevicesProcessed; }

  setNumberOfPlaybackDevicesStatsToDo(n: number) { this.numberOfPlaybackDevicesStatsToDo = n; }
  getNumberOfPlaybackDevicesStatsToDo() { return this.numberOfPlaybackDevicesStatsToDo; }

  setNumberOfPlaybackDevicesStatsDone(n: number) { this.numberOfPlaybackDevicesStatsDone = n; }
  getNumberOfPlaybackDevicesStatsDone() { return this.numberOfPlaybackDevicesStatsDone; }

  setNewGeofenceData(n: any[]) { this.newGeofenceData = n; }
  getNewGeofenceData() { return this.newGeofenceData; }

  setUserClusterList(n: any[]) { this.userClusterList = n; }
  getUserClusterList() { return this.userClusterList; }

 bakeThePie(options: BakeThePieOptions): string {
  const {
    data,
    valueFunc,
    outerRadius: r,
    innerRadius: rInner,
    strokeWidth,
    pathClassFunc = () => '',
    pieClass = '',
    pieLabel = '',
    pieLabelClass = ''
  } = options;

  const centerPoint = r + strokeWidth;
  const w = centerPoint * 2;
  const h = w;

  const pie = d3.pie<any>().value(valueFunc);
  const arc = d3.arc<any>().innerRadius(rInner).outerRadius(r);

  // Create SVG element
  const svg = d3.create('svg')
    .attr('class', pieClass)
    .attr('width', w)
    .attr('height', h);

  const arcs = svg.selectAll('g.arc')
    .data(pie(data))
    .enter()
    .append('g')
    .attr('class', 'arc')
    .attr('transform', `translate(${centerPoint},${centerPoint})`);

  arcs.append('path')
    .attr('class', pathClassFunc)
    .attr('stroke-width', strokeWidth)
    .attr('d', arc as any);

  svg.append('text')
    .attr('x', centerPoint)
    .attr('y', centerPoint)
    .attr('class', pieLabelClass)
    .attr('text-anchor', 'middle')
    .attr('dy', '.3em')
    .text(pieLabel);

  // Return SVG markup as string
  return svg.node()?.outerHTML || '';
}
}
  export interface BakeThePieOptions {
  data: any[];
  valueFunc: (d: any) => number;
  outerRadius: number;
  innerRadius: number;
  strokeWidth: number;
  pathClassFunc?: (d: any) => string;
  pieClass?: string;
  pieLabel?: string | number;
  pieLabelClass?: string;
}